import Vue from 'vue';

Vue.component('sales-mix-index', () =>
    import(/* webpackChunkName: 'sales-mix-index' */ './sales-mix-index.vue'),
);

Vue.component('sales-mix-datatable', () =>
    import(/* webpackChunkName: 'sales-mix-datatable' */ './sales-mix-datatable.vue'),
);
